<template>
    <div>
      <!-- 面包屑导航区域 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>商品价格管理</el-breadcrumb-item>
        <el-breadcrumb-item>经销商独立价格列表</el-breadcrumb-item>
      </el-breadcrumb>
  
      <!-- 卡片视图区域 -->
      <el-card>
        <el-row :gutter="20">
          <el-col :span="2" v-if="canLook == 1">
            <el-button type="primary" @click="goAddpage">添加价格</el-button>
          </el-col>
        </el-row>
  
        <!-- table表格区域 -->
        <el-table :data="goodslist" border stripe>
          <el-table-column type="index"></el-table-column>
          <el-table-column label="经销商名称" prop="agencyName"></el-table-column>
          <el-table-column label="商品原价格" align="center" prop="good_price" width="195px"></el-table-column>
          <el-table-column label="经销商价格" align="center" prop="price" width="195px"></el-table-column>
          <el-table-column label="操作" width="150px" v-if="canLook == 1">
            <template slot-scope="scope">
              <el-button type="primary" icon="el-icon-edit" size="mini" @click="editOrder(scope.row)"></el-button>
              <el-button size="mini" type="danger" icon="el-icon-delete" @click="removeById(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
  
        <!-- 分页区域 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pagenum"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="queryInfo.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
        >
        </el-pagination>

        <!-- 显示列表对话框 -->
        <el-dialog title="商品价格添加" :visible.sync="editGoodVisible" width="35%" @close="editGoodDialogClosed" center>
          <el-form :model="editGoodForm" :rules="editGoodFormRule" ref="editGoodFormRef" label-width="100px">
            <el-select v-model="addForm.user_id"  filterable  style="float: left;width: 400px;" placeholder="请选择经销商">
              <el-option
                v-for="item in tableData"
                :key="item.id"
                :label="item.agencyName"
                :value="item.id">
              </el-option>
            </el-select>
            <el-form-item label="价格" style="float: left;width: 200px">
          <el-input v-model="addForm.price"></el-input>
        </el-form-item>
          </el-form>
        <span slot="footer" class="dialog-footer" >
          <el-button @click="editGoodVisible = false">取 消</el-button>
          <el-button type="primary" @click="changeGoodClick">确定添加</el-button>
        </span>
      </el-dialog>
      </el-card>
    </div>
  </template>
  
  <script>
  import Detail from "./DetailList.vue"
  export default {
    components: {
      Detail
    },
    props:['valueId'],
    data () {
      return {
        de:false,
        order_id:'',
        editGoodVisible: false,
        canLook: 1,
        // 查询参数对象
        queryInfo: {
          query: '',
          good_id:'',
          pagenum: 1,
          pagesize: 10
        },
        addForm:{
          id:'',
          user_id:'',
          good_id:'',
          price:'',
        },
        tableData:[],
        // 商品列表
        goodslist: [],
        // 总数据条数
        total: 0
      }
    },
    watch: {
      valueId(val, oldVal) {
        // alert(val+'------'+oldVal)
        // if (val === oldVal) {
        //   return
        // }
        // if (this.valueId) {//编辑
          this.goodslist=[]
          this.queryInfo.good_id = val;
          this.addForm.good_id = val;
          this.getGoodsList();
          this.getGoodUserList()
        // }
      },
      visible(val, oldVal) {
        
        if (this.valueId) {//编辑
          this.goodslist=[]
          this.queryInfo.good_id = val;
          this.addForm.good_id = val;
          this.getGoodsList();
          this.getGoodUserList()
        }
      },
  },
    
    // created () {
    //   this.queryInfo.good_id = valueId
    //   this.getGoodsList()
    // },
    mounted(){
      if (this.valueId) {//编辑
        this.queryInfo.good_id = this.valueId;
        this.addForm.good_id = this.valueId;
        // this.show = this.$route.query.show;
        this.getGoodsList();
        this.getGoodUserList()
      }
    },
    methods: {
      // 关闭弹窗
      editGoodDialogClosed(){
        this.editGoodVisible = false
        
      },
      // 根据分页获取对应的商品列表
      async getGoodsList () {
        this.goodslist=[]
        const { data: res } = await this.$http.post('admin/good/UserGoodPricelist', {
          params: this.queryInfo
        })
        
        if (res.code !== 200) {
          return this.$message.error('获取商品列表失败！')
        }
  
        this.$message.success('获取商品列表成功！')
        this.goodslist = res.result.list
        this.total = res.result.count
        if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
          this.canLook = 2
        }
      },
       //保存价格
      async changeGoodClick(){
          const { data: res } = await this.$http.post('admin/good/addUserGoodPriceAttr', {
            data: this.addForm,
          })
          if (res.code !== 200) {
            return this.$message.error(res.result)
          }

          this.$message.success('保存成功！')
          this.editGoodVisible = false
          this.getGoodsList();
      },
      handleSizeChange (newSize) {
        this.queryInfo.pagesize = newSize
        this.getGoodsList()
      },
      handleCurrentChange (newPage) {
        this.queryInfo.pagenum = newPage
        this.getGoodsList()
      },
      async removeById (id) {
        const confirmResult = await this.$confirm(
          '此操作将永久删除该价格, 是否继续?',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).catch(err => err)
        if (confirmResult !== 'confirm') {
          return this.$message.info('已经取消删除！')
        }
        const { data: res } = await this.$http.post('admin/good/deleteUserGoodPrice', { id: id })
        if (res.code !== 200) {
          return this.$message.error('删除失败！')
        }
        this.$message.success('删除成功！')
        this.getGoodsList()
      },
  
      // 监听 switch 开关状态的改变
      async goodStateChanged (userinfo) {
        console.log(userinfo)
        const { data: res } = await this.$http.post('/admin/good/updateStatus', {
          status: userinfo.status,
          id: userinfo.id
        })
        if (res.code !== 200) {
          userinfo.mg_state = !userinfo.mg_state
          return this.$message.error('更新商品状态失败！')
        }
        this.$message.success('更新商品状态成功！')
      },
  
      goAddpage () {
        this.editGoodVisible =true
        // this.$router.push('/goods/add')
      },
      // 编辑
      editById (id) {
        console.log(id);
        this.$router.push({ path: '/goods/add', query: { id: id } })
  
      },
       // 编辑
       editOrder(val) {
        this.editGoodVisible =true
        this.addForm.id = val.id
        this.addForm.user_id = val.user_id
        this.addForm.price = val.price
      },
       // 获取此活动的商品
    async getGoodUserList () {
      const { data: res } = await this.$http.post('admin/good/getGoodUserList', {
        params: {
          id: ''
        }
      })
      if (res.code !== 200) {
        return this.$message.error('获取数据失败！')
      }
      this.tableData = res.result
    },
    }
  }
  </script>
  
  <style lang="less" scoped>
  .tip {
    font-size: 13px;
    color: #cccccc;
  }
  </style>
  